import { LAYOUTS, } from "@voltmoney/types";
import { ButtonTypeTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTIONS } from "./types";
import { goBack, marketingLogin } from "./actions";
import { onApplyNow, onChangeDimension } from "../MarketingLeads/actions";
export const template = (phone_number, isWhatsAppEnabled, setIsUserLoggedIn, lead, doLeadExist) => {
    return {
        layout: {
            id: ROUTE.MARKETING_LEAD_OTP,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "optRootStack", type: WIDGET.STACK },
            ],
        },
        datastore: {
            optRootStack: {
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    // { id: "space0", type: WIDGET.SPACE },
                    { id: "title", type: WIDGET.TEXT },
                    { id: "space1", type: WIDGET.SPACE },
                    { id: "subTitleStack", type: WIDGET.STACK },
                    { id: "space2", type: WIDGET.SPACE },
                    { id: "input", type: WIDGET.INPUT },
                ],
                dimensionAction: {
                    routeId: ROUTE.MARKETING_LEAD_OTP,
                    type: ACTIONS.GET_DIMENSION,
                    payload: {}
                }
            },
            back: {
                type: ButtonTypeTokens.IconGhost,
                icon: { name: IconTokens.Back, size: IconSizeTokens.XL },
            },
            title: {
                label: "Enter OTP",
                fontSize: FontSizeTokens.XL,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: "600",
            },
            subTitleStack: {
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "subTitle", type: WIDGET.TEXT },
                    { id: "subTitle2", type: WIDGET.TEXT },
                    { id: "editNumber", type: WIDGET.TEXT },
                ],
                action: {
                    type: ACTIONS.GO_BACK,
                    payload: {},
                    routeId: ROUTE.MARKETING_LEAD_OTP,
                },
            },
            subTitle: {
                label: `We’ve sent an OTP to `,
                color: ColorTokens.Grey_Charcoal,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "400",
            },
            subTitle2: {
                label: `${phone_number}`,
                color: ColorTokens.Grey_Charcoal,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "600",
            },
            editNumber: {
                label: `   Edit`,
                color: ColorTokens.Primary_100,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "600",
                paddingLeft: 6,
                paddingRight: 6,
            },
            input: {
                isFocus: true,
                title: "Enter OTP",
                type: InputTypeToken.OTP,
                state: InputStateToken.DEFAULT,
                keyboardType: KeyboardTypeToken.numberPad,
                charLimit: 4,
                action: {
                    type: ACTIONS.LoginWithCognito,
                    routeId: ROUTE.MARKETING_LEAD_OTP,
                    payload: {
                        phone: `${phone_number}`,
                        value: "",
                        widgetId: "input",
                        lead: lead,
                        doLeadExist: doLeadExist
                    },
                },
                otpAction: {
                    type: ACTIONS.RESEND_OTP_NUMBER,
                    payload: {
                        value: `${phone_number.toString().slice(3)}`,
                        widgetId: "input",
                        isResend: true,
                    },
                    routeId: ROUTE.MARKETING_LEAD_OTP,
                },
            },
            space0: { size: SizeTypeTokens.XXXL },
            space1: { size: SizeTypeTokens.SM },
            space2: { size: SizeTypeTokens.XXXL },
        },
    };
};
export const MarketingLeadOtp = {
    onLoad: async ({ instrumentTrack }, { phone_number, isWhatsAppEnabled, setIsUserLoggedIn, lead, doLeadExist }) => {
        instrumentTrack("SIGNUP_OTP_PAGE_VIEWED", { type: 'lead_form' });
        return Promise.resolve(template(phone_number, isWhatsAppEnabled, setIsUserLoggedIn, lead, doLeadExist));
    },
    actions: {
        [ACTIONS.LoginWithCognito]: marketingLogin,
        [ACTIONS.GO_BACK]: goBack,
        [ACTIONS.RESEND_OTP_NUMBER]: onApplyNow,
        [ACTIONS.GET_DIMENSION]: onChangeDimension,
    },
    clearPrevious: true,
};
